
<template>
  <div>
    <el-button
      style="float: right"
      size="mini"
      type="primary"
      class="m-b-5"
      plain
      @click="handleExport()"
      v-if="showExport"
      :loading="downloading"
      >导出</el-button
    >
    <el-table :data="list" border size="small">
      <el-table-column
        align="left"
        :label="category == 11 ? '使用日期' : '维修日期'"
        prop="used_date"
        v-if="category == 7 || category == 11"
      >
        <template slot-scope="scope">
          {{
            scope.row.used_date
              ? $time(scope.row.used_date).format('YYYY-MM-DD')
              : '-'
          }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="拆卸日期"
        prop="disassemb_date"
        v-if="category == 6 || category == 4"
      >
      </el-table-column>
      <el-table-column
        align="center"
        label="使用次数"
        prop="usage"
        v-if="category == 6"
      >
        <template slot-scope="scope">
          {{ scope.row.usage ? `第${scope.row.usage}次` : '-' }}
        </template>
      </el-table-column>
      <el-table-column
        label="拆检情况"
        prop="inspection"
        v-if="category == 6 || category == 4"
      >
      </el-table-column>
      <el-table-column align="center" label="是否使用" v-if="category == 6">
        <template slot-scope="scope">
          <span v-if="scope.row.is_used == 1">是</span>
          <span v-else-if="scope.row.is_used == 2">否</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="区块信息" v-if="category == 11">
        <template slot-scope="scope">
          <div v-for="param in scope.row.used_extra" :key="param.key">
            {{ param.label }}：{{ param.value }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="工作时长"
        prop="used_hour"
        v-if="category == 11"
      >
      </el-table-column>
      <el-table-column
        align="center"
        label="使用次数"
        prop="usage"
        v-if="category == 7"
      >
        <template slot-scope="scope">
          {{ scope.row.usage ? `第${scope.row.usage}次` : '-' }}
        </template>
      </el-table-column>
      <el-table-column
        label="维修更换情况"
        prop="inspection"
        v-if="category == 7"
      >
      </el-table-column>
      <el-table-column
        label="处理措施和结果"
        prop="solution"
        v-if="category == 7"
      >
      </el-table-column>
      <el-table-column align="center" label="操作人" prop="user_name">
      </el-table-column>
      <el-table-column align="center" label="操作时间" prop="created_at_human">
        <template slot-scope="scope">
          {{ $time(scope.row.created_at).format('YYYY-MM-DD HH:mm') }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="操作类型"
        prop="category_name"
        v-if="category == 0"
      >
      </el-table-column>
      <el-table-column align="left" label="操作内容" min-width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.used_date && category == 0">
            {{ scope.row.category == 7 ? '维修日期' : '使用日期' }}：{{
              $time(scope.row.used_date).format('YYYY-MM-DD')
            }}
          </div>
          <div v-if="[11].includes(scope.row.category) && category == 0">
            工作时长：{{ scope.row.used_hour }}
          </div>
          <div
            v-if="
              scope.row.used_extra &&
              scope.row.used_extra.length > 0 &&
              category == 0
            "
          >
            <template v-if="[13, 14].includes(scope.row.category)">
              <div class="font-12">附件</div>
              <div v-for="(param, index) in scope.row.used_extra" :key="index">
                <el-link
                  @click="handleDownload(param)"
                  type="primary"
                  class="font-12"
                  >{{ param.name }}</el-link
                >
              </div>
            </template>
            <template v-else>
              <div v-for="param in scope.row.used_extra" :key="param.key">
                {{ param.label }}：{{ param.value }}
              </div>
            </template>
          </div>
          <div v-if="scope.row.usage && category == 11">
            趟钻数：第{{ scope.row.usage }}趟
          </div>
          <div v-if="scope.row.up_well_time">
            钻进周期：{{ scope.row.down_well_time }}时 ~
            {{ scope.row.up_well_time }}时
          </div>
          <div
            v-if="scope.row.up_reason"
            v-html="'起钻原因：' + scope.row.up_reason"
          ></div>
          <div
            v-if="scope.row.malfunction"
            v-html="'故障描述：' + scope.row.malfunction"
          ></div>
          <div v-html="scope.row.remark"></div>
          <div class="medio-container">
            <el-image
              v-for="url in scope.row.imgs"
              :key="url"
              style="width: 30px; height: 30px; margin-right: 5px"
              :src="url"
              :preview-src-list="scope.row.imgs"
            >
            </el-image>
            <VideoPlayer :srcs="scope.row.videos"></VideoPlayer>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" v-if="category > 0">
        <template slot-scope="scope">
          <el-popconfirm
            v-if="[0, 4, 6, 11].includes(scope.row.category)"
            v-permission="
              product.category == 1
                ? Auth.productUseRecordDelete
                : Auth.instrumentUseRecordDelete
            "
            title="确认删除该使用记录吗？"
            @confirm="hanldeDelte(scope.$index, scope.row)"
          >
            <el-button slot="reference" type="danger" plain size="mini"
              >删除</el-button
            >
          </el-popconfirm>

          <template v-if="[7].includes(scope.row.category)">
            <el-popconfirm
              v-permission="
                product.category == 1
                  ? Auth.productRepairRecordDelete
                  : Auth.instrumentRepairUseRecordDelete
              "
              title="确认删除该维修记录吗？"
              @confirm="hanldeDelte(scope.$index, scope.row)"
            >
              <el-button slot="reference" type="danger" plain size="mini"
                >删除</el-button
              >
            </el-popconfirm>
            <el-button
              type="primary"
              plain
              size="mini"
              v-if="scope.row.user_id == $store.state.userInfo.id"
              @click="hanldeEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
          </template>

          <el-button
            type="primary"
            plain
            size="mini"
            v-if="category == 6"
            @click="handleShowDetail(scope.$index, scope.row)"
            >拆卸详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <RepairFormer
      :model="record"
      :show.sync="recordFormerVisible"
      @updated="recordUpdated"
    ></RepairFormer>

    <DisassembDetail
      :model="record"
      :category="product.category"
      :show.sync="detailVisible"
    ></DisassembDetail>
  </div>
</template>

<script>
import { productRecordList, productRecordDelete } from '@/service/getData'
import RepairFormer from './repair_former'
import store from '@/store/index'
import DisassembDetail from './disassemb_detail.vue'

export default {
  components: {
    RepairFormer,
    DisassembDetail,
  },
  props: {
    product: {
      type: Object,
    },
    category: {
      type: Number,
      default: 0,
    },
    showExport: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
      userInfo: store.state.userInfo,
      record: {},
      recordFormerVisible: false,
      detailVisible: false,
      downloading: false,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await productRecordList({
        product_id: this.product.id,
        category: this.category,
        page: 0,
        size: 100,
      })
      this.list = res.data.list
    },

    hanldeEdit(index, item) {
      this.record = { ...item }
      this.recordFormerVisible = true
    },

    handleShowDetail(index, item) {
      this.record = { ...item }
      this.detailVisible = true
    },

    recordUpdated(item) {
      let index = this.list.findIndex((v) => v.id === item.id)
      this.$set(this.list, index, item)
    },

    async hanldeDelte(index, row) {
      let res = await productRecordDelete(row.id)
      if (res.code === 0) {
        this.list.splice(index, 1)
      }
    },
    handleDownload(file) {
      const x = new window.XMLHttpRequest()
      x.open('GET', file.url, true)
      x.responseType = 'blob'
      x.onload = () => {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = file.name
        a.click()
      }
      x.send()
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          switch (j) {
            default:
              return v[j]
          }
        }),
      )
    },

    formartList(list) {
      let data = []
      let merges = []

      data = list.map((item) => {
        let content = ''
        if (item.used_date) {
          content +=
            (item.category == 7 ? '维修日期：' : '使用日期：') +
            this.$time(item.used_date).format('YYYY-MM-DD') +
            '\n'
        }
        if (item.category == 11) {
          content += '工作时长：' + item.used_hour + '\n'
        }

        if (
          item.category != 13 &&
          item.used_extra &&
          item.used_extra.length > 0
        ) {
          item.used_extra.map((p) => {
            content += p.label + '：' + p.value
          })

          content += '\n'
        }

        if (item.remark) {
          content += item.remark.replace(/<[^<>]+>/g, '')
        }
        return {
          name: item.user_name,
          time: this.$time(item.created_at).format('YYYY-MM-DD HH:mm'),
          category: item.category_name,
          content: content,
        }
      })
      return { list: data, merges: merges }
    },

    handleExport() {
      if (this.downloading) return
      this.downloading = true
      import('@/vendor/Export2Excel').then((excel) => {
        const tHeader = ['操作人', '操作时间', '操作类型', '操作内容']
        const filterVal = ['name', 'time', 'category', 'content']

        const d = this.formartList(this.list)
        const data = this.formatJson(filterVal, d.list)

        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: `${this.product.name}（${this.product.code}）操作日志`,
        })
        this.downloading = false
      })
    },
  },
}
</script>